module.exports = __webpack_public_path__ + "img/3-great.cf7b1e4c.jpg";